interface IconProps {
  className?: string;
  color?: string;
}

/**
 * Icône Horloge - Pour la durée des formations
 */
export function ClockIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Cercle extérieur */}
      <circle cx="50" cy="50" r="40" stroke={color} strokeWidth="6" fill="none"/>
      {/* Aiguille des heures */}
      <line x1="50" y1="50" x2="50" y2="30" stroke={color} strokeWidth="5" strokeLinecap="round"/>
      {/* Aiguille des minutes */}
      <line x1="50" y1="50" x2="65" y2="50" stroke={color} strokeWidth="4" strokeLinecap="round"/>
      {/* Point central */}
      <circle cx="50" cy="50" r="4" fill={color}/>
      {/* Marques d'heures */}
      <circle cx="50" cy="15" r="2" fill={color}/>
      <circle cx="50" cy="85" r="2" fill={color}/>
      <circle cx="15" cy="50" r="2" fill={color}/>
      <circle cx="85" cy="50" r="2" fill={color}/>
    </svg>
  );
}

/**
 * Icône Groupe - Pour le nombre de participants
 */
export function GroupIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Personne 1 (gauche) */}
      <circle cx="30" cy="35" r="12" fill={color} opacity="0.8"/>
      <path d="M15 70 Q15 50 30 50 Q45 50 45 70 Z" fill={color} opacity="0.8"/>

      {/* Personne 2 (centre) */}
      <circle cx="50" cy="30" r="14" fill={color}/>
      <path d="M32 75 Q32 52 50 52 Q68 52 68 75 Z" fill={color}/>

      {/* Personne 3 (droite) */}
      <circle cx="70" cy="35" r="12" fill={color} opacity="0.8"/>
      <path d="M55 70 Q55 50 70 50 Q85 50 85 70 Z" fill={color} opacity="0.8"/>
    </svg>
  );
}

/**
 * Icône Localisation - Pour le format (distanciel/présentiel)
 */
export function LocationIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Pin */}
      <path
        d="M50 10 C35 10 25 20 25 35 C25 55 50 85 50 85 C50 85 75 55 75 35 C75 20 65 10 50 10 Z"
        fill={color}
      />
      {/* Point intérieur */}
      <circle cx="50" cy="35" r="10" fill="white"/>
    </svg>
  );
}

/**
 * Icône Trophée - Pour QUALIOPI
 */
export function TrophyIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Coupe */}
      <path
        d="M35 20 L65 20 L60 50 Q60 60 50 60 Q40 60 40 50 Z"
        fill={color}
      />
      {/* Anses */}
      <path d="M30 25 Q20 25 20 35 Q20 40 25 40" stroke={color} strokeWidth="4" fill="none"/>
      <path d="M70 25 Q80 25 80 35 Q80 40 75 40" stroke={color} strokeWidth="4" fill="none"/>
      {/* Pied */}
      <rect x="45" y="60" width="10" height="15" fill={color}/>
      <rect x="35" y="75" width="30" height="5" rx="2" fill={color}/>
    </svg>
  );
}

/**
 * Icône Niveau - Pour le niveau de compétence
 */
export function LevelIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Barres de progression */}
      <rect x="15" y="65" width="15" height="25" rx="3" fill={color} opacity="0.4"/>
      <rect x="35" y="50" width="15" height="40" rx="3" fill={color} opacity="0.7"/>
      <rect x="55" y="35" width="15" height="55" rx="3" fill={color}/>
      {/* Flèche montante */}
      <path d="M80 40 L80 20 M80 20 L72 28 M80 20 L88 28" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/**
 * Icône Calendrier - Pour les dates
 */
export function CalendarIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Corps du calendrier */}
      <rect x="20" y="25" width="60" height="55" rx="5" stroke={color} strokeWidth="5" fill="white"/>
      {/* Barre supérieure */}
      <rect x="20" y="25" width="60" height="15" rx="5" fill={color}/>
      {/* Anneaux de suspension */}
      <rect x="30" y="15" width="5" height="15" rx="2" fill={color}/>
      <rect x="65" y="15" width="5" height="15" rx="2" fill={color}/>
      {/* Jour */}
      <text x="50" y="65" fontSize="24" fontWeight="bold" fill={color} textAnchor="middle" fontFamily="system-ui">15</text>
    </svg>
  );
}

/**
 * Icône Email - Pour le contact
 */
export function EmailIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Enveloppe */}
      <rect x="15" y="30" width="70" height="45" rx="5" stroke={color} strokeWidth="5" fill="white"/>
      {/* Rabat */}
      <path d="M15 30 L50 55 L85 30" stroke={color} strokeWidth="5" fill="none" strokeLinejoin="round"/>
    </svg>
  );
}

/**
 * Icône Paiement - Pour le paiement sécurisé
 */
export function PaymentIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Carte */}
      <rect x="10" y="30" width="80" height="50" rx="6" fill={color}/>
      {/* Bande magnétique */}
      <rect x="10" y="42" width="80" height="12" fill="white" opacity="0.3"/>
      {/* Puce */}
      <rect x="20" y="60" width="15" height="12" rx="2" fill="white" opacity="0.8"/>
      {/* Lignes de signature */}
      <line x1="45" y1="65" x2="75" y2="65" stroke="white" strokeWidth="2" opacity="0.6"/>
      <line x1="45" y1="72" x2="65" y2="72" stroke="white" strokeWidth="2" opacity="0.6"/>
    </svg>
  );
}

/**
 * Icône Objectifs - Pour les objectifs de formation
 */
export function TargetIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Cercles de cible */}
      <circle cx="50" cy="50" r="40" stroke={color} strokeWidth="4" fill="none" opacity="0.3"/>
      <circle cx="50" cy="50" r="28" stroke={color} strokeWidth="4" fill="none" opacity="0.5"/>
      <circle cx="50" cy="50" r="16" stroke={color} strokeWidth="4" fill="none" opacity="0.7"/>
      <circle cx="50" cy="50" r="6" fill={color}/>
      {/* Flèche */}
      <path d="M65 15 L50 50 M65 15 L60 20 M65 15 L70 20" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/**
 * Icône Livre - Pour la pédagogie
 */
export function BookIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Livre ouvert */}
      <path d="M50 25 Q35 20 20 25 L20 75 Q35 70 50 75 Z" fill={color} opacity="0.8"/>
      <path d="M50 25 Q65 20 80 25 L80 75 Q65 70 50 75 Z" fill={color}/>
      {/* Ligne centrale */}
      <line x1="50" y1="25" x2="50" y2="75" stroke="white" strokeWidth="2"/>
    </svg>
  );
}

/**
 * Icône Certificat - Pour l'évaluation
 */
export function CertificateIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Diplôme */}
      <rect x="20" y="20" width="60" height="50" rx="3" stroke={color} strokeWidth="4" fill="white"/>
      {/* Lignes de texte */}
      <line x1="30" y1="35" x2="70" y2="35" stroke={color} strokeWidth="2"/>
      <line x1="30" y1="45" x2="60" y2="45" stroke={color} strokeWidth="2" opacity="0.6"/>
      <line x1="30" y1="55" x2="65" y2="55" stroke={color} strokeWidth="2" opacity="0.6"/>
      {/* Ruban */}
      <circle cx="75" cy="55" r="12" fill={color}/>
      <path d="M75 67 L70 85 L75 78 L80 85 Z" fill={color}/>
      {/* Checkmark dans le ruban */}
      <path d="M70 53 L73 58 L82 48" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/**
 * Icône Données - Pour les supports et données
 */
export function DataIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Dossier */}
      <path d="M20 30 L45 30 L50 20 L80 20 L80 75 L20 75 Z" fill={color} opacity="0.3"/>
      <path d="M20 35 L80 35 L80 75 L20 75 Z" fill={color}/>
      {/* Icône de document à l'intérieur */}
      <rect x="35" y="47" width="30" height="20" rx="2" fill="white" opacity="0.8"/>
      <line x1="40" y1="53" x2="60" y2="53" stroke={color} strokeWidth="2"/>
      <line x1="40" y1="58" x2="55" y2="58" stroke={color} strokeWidth="2"/>
    </svg>
  );
}

/**
 * Icône Accessibilité - Pour l'accessibilité handicap
 */
export function AccessibilityIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Personne */}
      <circle cx="55" cy="25" r="10" fill={color}/>
      {/* Corps et bras */}
      <path d="M45 40 L65 40 L70 55 L60 80" stroke={color} strokeWidth="6" strokeLinecap="round"/>
      {/* Fauteuil */}
      <circle cx="45" cy="75" r="12" stroke={color} strokeWidth="5" fill="none"/>
      <circle cx="70" cy="75" r="8" stroke={color} strokeWidth="4" fill="none"/>
      {/* Main-courante */}
      <path d="M35 60 Q30 65 32 75" stroke={color} strokeWidth="5" strokeLinecap="round" fill="none"/>
    </svg>
  );
}

/**
 * Icône Prérequis - Pour les prérequis techniques
 */
export function LaptopIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Écran */}
      <rect x="25" y="20" width="50" height="40" rx="3" stroke={color} strokeWidth="4" fill="white"/>
      {/* Base/clavier */}
      <path d="M15 60 L20 65 L80 65 L85 60 Z" fill={color}/>
      {/* Indicateur de caméra */}
      <circle cx="50" cy="25" r="2" fill={color}/>
    </svg>
  );
}

/**
 * Icône Check Circle - Pour les validations et objectifs
 */
export function CheckCircleIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Cercle */}
      <circle cx="50" cy="50" r="40" fill={color}/>
      {/* Checkmark */}
      <path
        d="M30 50 L45 65 L72 35"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

/**
 * Icône Formation - Pour l'icône générale de formation
 */
export function GraduationIcon({ className = "w-6 h-6", color = "#F06C6E" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Chapeau */}
      <path d="M50 20 L90 35 L50 50 L10 35 Z" fill={color}/>
      {/* Tasseau central */}
      <path d="M50 50 L50 75" stroke={color} strokeWidth="5"/>
      {/* Base */}
      <path d="M35 75 Q50 85 65 75" stroke={color} strokeWidth="5" fill="none" strokeLinecap="round"/>
      {/* Côtés de la toque */}
      <path d="M10 35 L10 50 Q25 60 50 50" stroke={color} strokeWidth="4" fill="none"/>
      <path d="M90 35 L90 50 Q75 60 50 50" stroke={color} strokeWidth="4" fill="none"/>
    </svg>
  );
}

/**
 * Icône Ampoule - Pour les informations importantes
 */
export function LightbulbIcon({ className = "w-6 h-6", color = "#EAB308" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Ampoule */}
      <path
        d="M50 15 C35 15 25 28 25 42 C25 52 30 60 37 65 L37 75 L63 75 L63 65 C70 60 75 52 75 42 C75 28 65 15 50 15 Z"
        fill={color}
      />
      {/* Culot */}
      <rect x="40" y="75" width="20" height="8" fill={color} opacity="0.7"/>
      <rect x="42" y="83" width="16" height="4" rx="2" fill={color} opacity="0.7"/>
      {/* Filament */}
      <path d="M50 30 L50 55" stroke="white" strokeWidth="3" opacity="0.8"/>
      <path d="M43 40 L57 45" stroke="white" strokeWidth="2" opacity="0.6"/>
      <path d="M43 48 L57 42" stroke="white" strokeWidth="2" opacity="0.6"/>
    </svg>
  );
}
